export { EditContributorAllocationModalLoader } from './EditContributorAllocationModalLoader';
